'use client';

import { FC, memo } from 'react';
import clsx from 'clsx';
import { PropType } from './types';
import styles from '../EmblaCarousel.module.css';

export const PrevButton: FC<PropType> = memo((props) => {
  const { children, buttonsAbsolute, arrowClassName, backArrowClasses, className, ...restProps } = props;
  return (
    <button
      className={clsx(
        styles.carouselButtons,
        styles.backButton,
        {
          [styles.carouselButtonLeft]: buttonsAbsolute,
        },
        arrowClassName,
        backArrowClasses,
      )}
      type="button"
      {...restProps}
    >
      {children}
    </button>
  );
});

export const NextButton: FC<PropType> = memo((props) => {
  const { children, buttonsAbsolute, arrowClassName, nextArrowClasses, ...restProps } = props;
  return (
    <button
      className={clsx(
        styles.carouselButtons,
        styles.nextButton,
        {
          [styles.carouselButtonRight]: buttonsAbsolute,
        },
        arrowClassName,
        nextArrowClasses,
      )}
      type="button"
      {...restProps}
    >
      {children}
    </button>
  );
});
